<template lang="pug">
div
  v-card(flat)
    v-toolbar(color="primary" dark dense card)
      v-toolbar-title.body-2 {{ label }} {{ items.length > 0 ? '(' + items.length + ')' : '' }}
      v-spacer
  v-list
    template(v-for="(item, index) in localItems")
      v-list-tile(@click="download(item.url)")
        v-list-tile-avatar
          v-icon.grey.lighten-1.white--text fa-md {{ getIcon(item.type) }}
        v-list-tile-content
          v-list-tile-title {{ item.fileName }}
          v-list-tile-sub-title {{ item.author }}
        v-list-tile-action
          v-list-tile-action-text.text-xs-right {{ $moment(item.uploadDate).format('DD-MM-YYYY') }}
      v-divider(:key="index")
</template>

<script>
import minioAPI from '@/services/minio'
import MimeTypeIcons from '@/utils/mimeTypeIcons'
import PrettyBytes from 'prettier-bytes'

export default {
  name: 'FileDownloader',

  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: () => this.$tf('fileDownloader.label'),
    },
    items: {
      default: () => ([]),
      type: Array,
    },
  },

  data() {
    return {
      localItems: null,
    }
  },

  watch: {
    'items'(value) {
      this.localItems = value
      minioAPI.presignedGetObjectUrls(this.items).then((result) => {
        this.localItems = result.data
      })
    },
  },

  mounted() {
    this.localItems = this.items
    minioAPI.presignedGetObjectUrls(this.items).then((result) => {
      this.localItems = result.data
    })
  },

  methods: {
    prettyBytes(bytes) {
      return PrettyBytes(bytes)
    },
    getIcon(type) {
      return MimeTypeIcons.get(type)
    },
    download(url) {
      if (window.cordova !== undefined) {
        window.cordova.InAppBrowser.open(url, '_system', 'hidenavigationbuttons=yes,hideurlbar=yes,zoom=no,toolbarcolor=#272727,closebuttoncolor=#ffffff')
      } else {
        window.open(url, '_system')
      }
    },
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/utils/FileDownloader/FileDownloader.vue